import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { useIsDesktop } from '@alfalab/core-components-mq/esm';
import { ButtonDesktop } from './desktop/Component.desktop.js';
import { ButtonMobile } from './mobile/Component.mobile.js';

var Button = forwardRef(function (_a, ref) {
    var children = _a.children, breakpoint = _a.breakpoint, client = _a.client, _b = _a.defaultMatchMediaValue, defaultMatchMediaValue = _b === void 0 ? client === undefined ? undefined : client === 'desktop' : _b, restProps = __rest(_a, ["children", "breakpoint", "client", "defaultMatchMediaValue"]);
    var isDesktop = useIsDesktop(breakpoint, defaultMatchMediaValue);
    var Component = isDesktop ? ButtonDesktop : ButtonMobile;
    return (React.createElement(Component, __assign({ ref: ref }, restProps), children));
});
Button.displayName = 'Button';

export { Button };
